import cancelEvent from './cancelEvent';

function addTabSpacesTotextarea(e) {
    if (e.ctrlKey || e.cmdKey || e.altKey) { return; }
    
    const tab_sz = 2;
    const target = e.target;
    const text = target.value;
    var original_start = target.selectionStart;
    var original_end = target.selectionEnd;
    var selection_start = original_start;
    var selection_end = original_end;
    const selection = (selection_start !== selection_end);

    switch (e.key) {
        case 'Tab':
            cancelEvent(e);
            var remove = e.shiftKey;
            if (!selection && !remove) {
                while ((selection_start > 0) && (text[selection_start - 1] !== '\n')) { 
                    selection_start--; 
                }
                var pos = 0;
                while (selection_start < original_start) {
                    pos += text[selection_start] === '\t' ? tab_sz - (pos % tab_sz) : 1;
                    selection_start++;
                }
                const insert = ' '.repeat(tab_sz - (pos % tab_sz));
                document.execCommand('insertText', false, insert);
                original_start += insert.length;
                original_end += insert.length;
            }
            else {
                while ((selection_start > 0) && (text[selection_start - 1] !== '\n')) { 
                    selection_start--; 
                }
                const first_line_start = selection_start;
                selection_end = Math.max(selection_end, selection_start + 1);
                selection_end = Math.min(selection_end, text.length - 1);
                while ((text[selection_end - 1] !== '\n') && (selection_end < text.length)) { 
                    selection_end++; 
                }
                const lines = text.substr(selection_start, (selection_end - selection_start)).split('\n');
                for (var n = 0; n < lines.length; n++) {
                    if (((n === (lines.length - 1)) && (lines[n].length === 0)) || (lines[n].length === 0)) { 
                        continue; 
                    }
                    if (!remove) {
                        const prepend = ' '.repeat(tab_sz);
                        lines[n] = prepend + lines[n];
                        original_start += ((n === 0) ? prepend.length : 0);
                        original_end += prepend.length;
                    }
                    else {
                        if (lines[n].startsWith('\t')) {
                            lines[n] = lines[n].substr(1);
                            const anchor = selection ? selection_start : Math.max(selection_start, first_line_start);
                            original_start = Math.max((original_start - ((n === 0) ? 1 : 0)), anchor);
                            original_end = selection ? original_end - 1 : original_start;
                        }
                        else {
                            var spcs = tab_sz;
                            while (spcs > 0) {
                                if (lines[n].startsWith(' '.repeat(spcs))) {
                                    lines[n] = lines[n].substr(spcs);
                                    const anchor = selection ? selection_start : Math.max(selection_start, first_line_start);
                                    original_start = Math.max((original_start - ((n === 0) ? spcs : 0)), anchor);
                                    original_end = selection ? original_end - spcs : original_start;
                                    break;
                                }
                                spcs--;
                            }
                        }
                    }
                }
                target.selectionStart = selection_start;
                target.selectionEnd = selection_end;
                document.execCommand('insertText', false, lines.join('\n'));
            }
            target.setSelectionRange(original_start, original_start);
            target.blur();
            target.focus();
            target.setSelectionRange(original_start, original_end);
            break;
        default:
            break;
    }
}

export default addTabSpacesTotextarea;
